import { BookComponent } from './book.component';

export const bookrouts = [
  {
    path: '', children: [
    {path: '', component: BookComponent}
  ]
  },
  {
    path: 'sd', component: BookComponent
  }

];



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/+book/book.routes.ts